import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#680B14',
                secondary: '#F5F5DC',
            }
        }
        
    }
});
